import { createFileRoute } from '@tanstack/react-router'
import { ProductsLayout } from '@/features/products/components'

export const Route = createFileRoute('/_authenticated/products')({
  component: ProductsLayout,
})
